const styles = {
  container:
    "w-[185px] px-6 py-2 text-lg text-center cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-900 bg-white dark:bg-defaultBlack dark:text-white rounded-lg text-black",
};
export default styles;
